@if (settings?.isAllowedToPreventTransferToSupplier || settings?.isAllowedToPreventTransferToCustomerErp) {
  <iim-card
    [header]="transmissionHeader"
    >
    <ng-template #transmissionHeader>
      <div class="col">
        <div class="row">
          <div class="col">
            <h3>
              <em class="fas fa-right-left pe-2"></em>
              {{ 'Übertragungen' | translate }}
            </h3>
          </div>
        </div>
      </div>
    </ng-template>
    <div class="col">
      <client-erp-transmission
        [(value)]="demand.transmissionInfo"
        [readonly]="demand.readOnly"
        (valueChange)="demand.saveTransmissionInfo()"
      ></client-erp-transmission>
    </div>
  </iim-card>
}
